import {ConnectBasicEntityExt} from '../../framework/message/ConnectBasicEntityExt';
import {ConnectionConfigurationObj} from './ConnectionConfigurationObj';
import {TranslatedEmb} from '../../../../allkey/locale/message/TranslatedEmb';

export class Connection extends ConnectBasicEntityExt {
description: TranslatedEmb;
kind: string;
label: TranslatedEmb;
params: ConnectionConfigurationObj;
}

